import { FakeLeftMenu } from "./FakeLeftMenu";

export default FakeLeftMenu;
